import { Component, Renderer2, ElementRef, Input } from '@angular/core';
import { FinanceService } from '../../services/finance.services';

@Component({
    selector: 'timeline-card',
    templateUrl: 'timeline-card.component.html',
    styleUrls: ['timeline-card.component.scss'],
})

export class TimelineCardComponent {

    @Input() public initialValue: number;
    @Input() public monthlyValue: number;
    @Input() public itens: object[];
    @Input() public profile;

    public valueSavings: number;
    public title = '';
    public calculatedValue: number;
    public valueBank: number;

    private mouseMoveListen: (...args: any[]) => any;

    constructor(
        private renderer: Renderer2,
        private elementRef: ElementRef,
        private financeService: FinanceService,
    ) {}

    public ngOnInit() {

        const containerWidth = this.elementRef.nativeElement.firstChild.clientWidth;
        const itensLength = this.itens.length;
        const breakPositions = [];
        const spaceBetween = Math.floor(containerWidth / itensLength);
        const offset = Math.floor(spaceBetween * (itensLength / 2) / itensLength);

        this.itens.map((e, i) => {
            if (i === 0) {
                breakPositions.push({
                    position: 0,
                });
            } else if (i > 0 && i < itensLength - 1) {
                breakPositions.push({
                    position: spaceBetween * i + offset,
                });
            } else if (i === itensLength - 1) {
                breakPositions.push({
                    position: containerWidth,
                });
            }
        });

        let tax = '';

        if (this.profile === 2) {
            tax = '115';
        } else if (this.profile === 3) {
            tax = '141';
        } else if (this.profile === 4) {
            tax = '157';
        }

        this.calculatedValue = this.financeService.calculateTax(this.initialValue, tax, 120, 'CDI', 7, this.monthlyValue);
        this.valueBank = this.financeService.calculateTax(this.initialValue, 80, 120, 'CDI', 7, this.monthlyValue);
        this.valueSavings = this.financeService.calculateTax(this.initialValue, 100, 120, 'Poupança', 9, this.monthlyValue);
    }

    public mouseDown($e) {
        if (!this.mouseMoveListen()) {
            this.mouseMoveListen = this.renderer.listen(this.elementRef.nativeElement, 'touchmove', ($event) => {
                this.onMouseMove($event);
            });
        }
    }

    public mouseUp($e) {
        this.mouseMoveListen();
    }

    public onMouseMove($mouseEventMove) {
        const moviment = this.calculeWhenMoviment($mouseEventMove);
        if (moviment.condition) {
            this.dotMoviment(moviment.moviment);
            this.lineMoviment(moviment.moviment);
        }
    }

    public calculeWhenMoviment($mouseEventMove) {
        const offsetLeft = this.elementRef.nativeElement.getBoundingClientRect().left;
        const containerWidth = this.elementRef.nativeElement.firstChild.clientWidth;
        const offsetEnd = containerWidth + offsetLeft;

        const xMouseMoviment = $mouseEventMove.pageX;

        return {
            condition: xMouseMoviment >= offsetLeft && xMouseMoviment <= offsetEnd,
            moviment: xMouseMoviment - offsetEnd + containerWidth,
        };
    }

    public dotMoviment(positision) {
        const target = this.elementRef.nativeElement.querySelector('#timeline--dot');
        target.style.left = positision - 15 + 'px';
    }

    public lineMoviment(positision) {
        const target = this.elementRef.nativeElement.querySelector('#timeline--dotline');
        const containerWidth = this.elementRef.nativeElement.firstChild.clientWidth;
        const percentMov = Math.floor((positision / containerWidth) * 100);
        target.style.width = percentMov + '%';
    }
}
